/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityInternalDialog extends SiteEntityDialog<SecurityInternalRow, any> {
        protected getFormKey() { return SecurityInternalForm.formKey; }
        protected getIdProperty() { return SecurityInternalRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityInternalRow.localTextPrefix; }
        protected getNameProperty() { return SecurityInternalRow.nameProperty; }
        protected getService() { return SecurityInternalService.baseUrl; }

        protected form = new SecurityInternalForm(this.idPrefix);

        constructor(options?: any) {
            super(options);

            this.form.GicsSelection.change(e => {
                SecurityDialog.gicsSetFormValues(this.form, false, null);
            });
        }

        loadEntity(entity) {
            super.loadEntity(entity);
            SecurityDialog.gicsLoadEntity(entity, this.form);
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            SecurityDialog.gicsSaveEntity(entity);
            return entity;
        }
    }
}